export interface GtmTrackingContext {
  eventTitle?: string;
  eventSlug?: string;
  gtmContainerId?: string;
}

let currentTrackingContext: GtmTrackingContext = {};

export function setGtmTrackingContext(context: GtmTrackingContext): void {
  currentTrackingContext = context;
}

export function getGtmTrackingContext(): GtmTrackingContext {
  return currentTrackingContext;
}

export function clearGtmTrackingContext(): void {
  currentTrackingContext = {};
}
